// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header-Formate {
  position: fixed;
  z-index: 99;
  top: 0;
  left: 0;
  width: 100%;
  height: 80px;
  background-color: var(--gray-20);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-sizing: border-box;
  overflow: hidden;
  border-bottom: 2px solid var(--borderColor);
}

.Image-Formate img {
  position: relative;
  margin-left: 20px;
  display: flex;
  scale: 1.3;
  align-items: center;
}

.Title-Formate {
  position: absolute;
  width: 100%; /* Set the width with a minimum left spacing of 50px */
  text-align: calc(center - 300%);
  text-align: center;
  font-size: 16px;
  font-family: var(--inter-body-1-medium);
  color: var(--gray-100);
  right: 50px;
}

.search-bar-container {
  padding: 5px 20px;
  display: flex;
  align-items: center;
  background-color: var(--searchbar-background);
  border-radius: 50px;
  border: 1px solid var(--borderColor); /* Black border for title */
}

.search-logo {
  width: 30px;        /* Adjust the width as needed */
  height: 30px;       /* Adjust the height as needed */
  margin-right: 10px; /* Adjust the margin as needed */
}

.search-input {
  flex: 1 1;
  border: none;
  outline: none;
  padding: 10px;
  border-radius: 5px;
  font-size: 15px;   /* Adjust the font size as needed */
  font-family: var(--inter-body-1-medium);
  background-color: var(--searchbar-background);
}

.Buttons-Formate {
  display: flex;
  align-items: center;
  gap: 20px; /* Adjust the gap between search bar and buttons */
}

.Buttons-Formate button {
  padding: 10px 20px;
  border: 1px solid var(--borderColor); /* Black border for buttons */
  background-color: var(--gray-20); /* Change the background color as needed */
  color: var(--gray-100); /* Change the text color as needed */
  cursor: pointer;
}

/* Disable horizontal scrollbar when content fits */
.Header-Formate::-webkit-scrollbar {
  height: 0;
  width: 0;
}`, "",{"version":3,"sources":["webpack://./src/widgets/HeaderWidget.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,WAAW;EACX,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW,EAAE,sDAAsD;EACnE,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,uCAAuC;EACvC,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,6CAA6C;EAC7C,mBAAmB;EACnB,oCAAoC,EAAE,2BAA2B;AACnE;;AAEA;EACE,WAAW,SAAS,+BAA+B;EACnD,YAAY,QAAQ,gCAAgC;EACpD,kBAAkB,EAAE,gCAAgC;AACtD;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,eAAe,IAAI,mCAAmC;EACtD,uCAAuC;EACvC,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS,EAAE,kDAAkD;AAC/D;;AAEA;EACE,kBAAkB;EAClB,oCAAoC,EAAE,6BAA6B;EACnE,gCAAgC,EAAE,0CAA0C;EAC5E,sBAAsB,EAAE,oCAAoC;EAC5D,eAAe;AACjB;;AAEA,mDAAmD;AACnD;EACE,SAAS;EACT,QAAQ;AACV","sourcesContent":[".Header-Formate {\r\n  position: fixed;\r\n  z-index: 99;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 80px;\r\n  background-color: var(--gray-20);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 0 20px;\r\n  box-sizing: border-box;\r\n  overflow: hidden;\r\n  border-bottom: 2px solid var(--borderColor);\r\n}\r\n\r\n.Image-Formate img {\r\n  position: relative;\r\n  margin-left: 20px;\r\n  display: flex;\r\n  scale: 1.3;\r\n  align-items: center;\r\n}\r\n\r\n.Title-Formate {\r\n  position: absolute;\r\n  width: 100%; /* Set the width with a minimum left spacing of 50px */\r\n  text-align: calc(center - 300%);\r\n  text-align: center;\r\n  font-size: 16px;\r\n  font-family: var(--inter-body-1-medium);\r\n  color: var(--gray-100);\r\n  right: 50px;\r\n}\r\n\r\n.search-bar-container {\r\n  padding: 5px 20px;\r\n  display: flex;\r\n  align-items: center;\r\n  background-color: var(--searchbar-background);\r\n  border-radius: 50px;\r\n  border: 1px solid var(--borderColor); /* Black border for title */\r\n}\r\n\r\n.search-logo {\r\n  width: 30px;        /* Adjust the width as needed */\r\n  height: 30px;       /* Adjust the height as needed */\r\n  margin-right: 10px; /* Adjust the margin as needed */\r\n}\r\n\r\n.search-input {\r\n  flex: 1;\r\n  border: none;\r\n  outline: none;\r\n  padding: 10px;\r\n  border-radius: 5px;\r\n  font-size: 15px;   /* Adjust the font size as needed */\r\n  font-family: var(--inter-body-1-medium);\r\n  background-color: var(--searchbar-background);\r\n}\r\n\r\n.Buttons-Formate {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 20px; /* Adjust the gap between search bar and buttons */\r\n}\r\n\r\n.Buttons-Formate button {\r\n  padding: 10px 20px;\r\n  border: 1px solid var(--borderColor); /* Black border for buttons */\r\n  background-color: var(--gray-20); /* Change the background color as needed */\r\n  color: var(--gray-100); /* Change the text color as needed */\r\n  cursor: pointer;\r\n}\r\n\r\n/* Disable horizontal scrollbar when content fits */\r\n.Header-Formate::-webkit-scrollbar {\r\n  height: 0;\r\n  width: 0;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
